import React from "react";
import styled from "@emotion/styled";
import { border, borderRadius } from "@atlas-int/tokens";

export interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  /** When true, removes inner borders and radius so buttons appear as one unit */
  attached?: boolean;
  children: React.ReactNode;
}

const ButtonGroupRoot = styled.div<{ $attached: boolean }>`
  display: inline-flex;

  ${({ $attached }) =>
    $attached
      ? `
    border: 1px solid ${border.strong};
    border-radius: ${borderRadius.base};

    & > button {
      border-radius: 0;
      border: none;
      flex: 1;
    }
    & > button:first-of-type {
      border-top-left-radius: ${borderRadius.base};
      border-bottom-left-radius: ${borderRadius.base};
    }
    & > button:last-of-type {
      border-top-right-radius: ${borderRadius.base};
      border-bottom-right-radius: ${borderRadius.base};
    }
    & > button + button {
      border-left: 1px solid ${border.strong};
    }
  `
      : ""}
`;

const ButtonGroup = React.forwardRef<HTMLDivElement, ButtonGroupProps>(
  ({ attached = false, children, ...props }, ref) => (
    <ButtonGroupRoot ref={ref} $attached={attached} {...props}>
      {children}
    </ButtonGroupRoot>
  ),
);

ButtonGroup.displayName = "ButtonGroup";

export default ButtonGroup;
